var render = function render(){var _vm=this,_c=_vm._self._c;return _c('md-table-cell',{staticClass:"text-center"},[_vm._v(" "+_vm._s(this.formattedDate)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }